<div class="tunnel-page-container">
  <div class="body-container">
    <div class="casto-card">
      <ng-casto-project-title
        [title]="service.configuration.title"
        [disabled]="isLocked"
        (titleChange)="onTitleChange($event)"></ng-casto-project-title>
      <ng-casto-carpentry-product-list
        [products]="store.products"
        [totalAmount]="store.totalAmount"
        [discountOptionsMap]="store.discountOptionsMap"
        [tvaOptions]="store.tvaOptions"
        [loader]="store.loader"
        [expandedRows]="expandedRows"
        [readOnly]="isLocked"
        (addProduct)="store.addProduct()"
        (edit)="store.editRecord($event)"
        (duplicateRecord)="store.copyRecord($event)"
        (delete)="store.deleteRecord($event)"
        (quantityChange)="store.onQuantityChange($event)"
        (discountChange)="store.onDiscountChange($event.product, $event.value)"
        (tvaChange)="store.onTvaChange($event)"
        [tableMaxHeight]="'60vh'"
        [latestOrder]="store.order"
        [sortDirections]="store.sortDirections"
        (sortToggle)="store.toggleSort($event)"
        (orderEdition)="store.openOrderNumberEdition()"></ng-casto-carpentry-product-list>
    </div>
  </div>
  <div class="action-bar-container">
    <ng-casto-action-bar
      [beforeNext]="beforeNextAction.bind(this)"
      [specificPrintAction]="store.printList.bind(store)"
      [forceSpecificPrintActionEnabled]="true"></ng-casto-action-bar>
  </div>
</div>
